import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import AudioContainer from '../../../common/audio/audioContainer';
import PassageLayout from '../../../common/layouts/passageLayout';
import ClozeText from '../../../common/components/ClozeText';
import GoButton from '../../../common/components/GoButton';
import TextPaneScroll from '../../../common/textPaneScroll/TextPaneScroll';
import { MODEL } from '../../../constants/assessmentItemType';
import { ApolloContext } from '../../../ApolloContextProvider';
import { ARIA_LABELS } from '../../../constants/text';
import { getScrollStepSize } from '../../mazeUtils';

class MazeModelView extends React.Component {
    constructor(props) {
        super(props);
        this.getScrollableContent = this.getScrollableContent.bind(this);
        this.getScrollStep = this.getScrollableContent.bind(this);
    }

    componentDidMount() {
        if (!this.props.isDataFetched) {
            this.props.fetchContent();
        } else {
            this.props.narrateScreen();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isDataFetched && this.props.isDataFetched) {
            this.props.narrateScreen();
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    getScrollableContent() {
        const titleSegment = <h1 key="text-title">{this.props.title}</h1>;
        const textSegment = (
            <div className="lined-text">
                {this.props.paragraphs.map(paragraph => (
                    <ClozeText
                        isTabIndexActive={!this.props.isScreenBlocked && !this.props.isGreyedOut}
                        key={paragraph.id}
                        text={paragraph.text}
                        questions={this.props.questions}
                        selectedResponses={this.props.selectedResponses}
                        onResponseSelected={this.props.onResponseSelected}
                    />
                ))}
            </div>
        );
        const buttonSegment = this.props.isNextButtonActive ? (
            <GoButton
                isEnabled={!this.props.isScreenBlocked}
                onClick={this.props.onNext}
                ariaLabel={ARIA_LABELS.CONTINUE_DIRECTIONS}
            />
        ) : null;
        return [titleSegment, textSegment, buttonSegment];
    }

    render() {
        return (
            <PassageLayout
                class={classNames(`daze-measure ${MODEL}`, {
                    'is-extended-view': this.props.isExtendedView,
                })}
                isGreyedOut={this.props.isGreyedOut}
                isScreenBlocked={this.props.isScreenBlocked}
            >
                <AudioContainer />
                <div className="text-pane">
                    <div className="daze-text">
                        <div className="content">
                            <TextPaneScroll
                                isTabIndexDisabled={
                                    this.props.isGreyedOut || this.props.isScreenBlocked
                                }
                                scrollToSection="segment-part-one"
                                scrollStep={getScrollStepSize(
                                    this.props.isExtendedView,
                                    this.context.fontSizeScaleValue,
                                )}
                                isEnabled={this.props.isDataFetched}
                                content={this.getScrollableContent()}
                            />
                        </div>
                    </div>
                </div>
            </PassageLayout>
        );
    }
}

MazeModelView.propTypes = {
    isDataFetched: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isNextButtonActive: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
    title: PropTypes.string,
    paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        }),
    ),
    questions: PropTypes.array,
    selectedResponses: PropTypes.object,
    onResponseSelected: PropTypes.func,
    fetchContent: PropTypes.func,
    narrateScreen: PropTypes.func,
    onNext: PropTypes.func,
    cleanup: PropTypes.func,
    isExtendedView: PropTypes.bool,
};

MazeModelView.defaultProps = {
    isDataFetched: false,
    isScreenBlocked: false,
    isNextButtonActive: false,
    isGreyedOut: false,
    title: '',
    paragraphs: [],
    questions: [],
    selectedResponses: {},
    onResponseSelected: () => {},
    fetchContent: () => {},
    narrateScreen: () => {},
    onNext: () => {},
    cleanup: () => {},
    isExtendedView: false,
};
MazeModelView.contextType = ApolloContext;

export default MazeModelView;
